import React from 'react';
import { FormFieldHeader } from '../../../components/FormFieldHeader';
import { RichTextEditor } from '../../../components/RichTextEditor';
import { FormState } from './FormState';
import { InputRichTextComposer } from '../../../components/RichTextEditor/composers/InputRichTextComposer';
import { UpdateStatePlugin } from '../../../components/RichTextEditor/plugins/UpdateStatePlugin';
import { PasteVariablePlugin } from '../../../components/RichTextEditor/plugins/PasteVariablePlugin';
import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { TEMPLATE_VARIABLES } from './EmailVariables';
import { EmailTemplate } from '../../../entities/EmailTemplate';

interface PropTypes {
  control: Control<FormState>;
  getValues: UseFormGetValues<FormState>;
  setValue: UseFormSetValue<FormState>;
  basedOnEmailTemplate?: EmailTemplate;
}

export function EmailSubject(props: PropTypes) {
  return (
    <div>
      <FormFieldHeader fieldName={'Subject'} isRequired={true} />
      <RichTextEditor<FormState>
        formHookContext={{
          controllerName: 'emailSubjectJson',
          formControl: props.control,
          required: true,
        }}
        render={(field) => (
          <InputRichTextComposer
            defaultEditorState={field.value as string}
            onChangeText={(value) => props.setValue('emailSubjectPlain', value)}
            onChangeJson={(value: string) => field.onChange(value)}
            externalPlugins={[
              <UpdateStatePlugin
                key={1}
                editorState={props.basedOnEmailTemplate?.subject}
              />,
              <PasteVariablePlugin
                key={2}
                variables={Object.values(TEMPLATE_VARIABLES)}
              />,
            ]}
            placeholder='Insert Subject'
          />
        )}
      />
    </div>
  );
}
